import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import faqImg from '../../assets/img/spot-help.png'
import { Icon } from '../Icon/Icon'
import styles from './Faq.module.scss'

const ITEM_KEYS = ['branch', 'discount', 'app', 'after', 'bonuses', 'destinations', 'receive']

export const Faq = () => {
  const { t } = useTranslation()
  const [openKey, setOpenKey] = useState<string | null>(ITEM_KEYS[0])

  return (
    <section className={styles.section} id="faq">
      <div className={`container ${styles.inner}`}>
        <div>
          <h2 className={styles.title}>{t('faq.title')}</h2>
          <p className={styles.subtitle}>{t('faq.subtitle')}</p>
          <ul className={styles.list}>
            {ITEM_KEYS.map((key) => {
              const isOpen = openKey === key
              return (
                <li key={key} className={`${styles.item}${isOpen ? ` ${styles.open}` : ''}`}>
                  <button
                    aria-expanded={isOpen}
                    className={styles.question}
                    type="button"
                    onClick={() => {
                      setOpenKey(isOpen ? null : key)
                    }}
                  >
                    <span>{t(`faq.items.${key}.question`)}</span>
                    <Icon className={styles.chevron} name="chevron-down" size={24} />
                  </button>
                  <div aria-hidden={!isOpen} className={styles.answerWrap}>
                    <p className={styles.answer}>{t(`faq.items.${key}.answer`)}</p>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
        <div className={styles.media}>
          <img
            alt=""
            className={styles.image}
            height="400"
            loading="lazy"
            src={faqImg}
            width="400"
          />
        </div>
      </div>
    </section>
  )
}
